// Core modules
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { PushSubscriptionService } from '@app/core/services/pushsubscription.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  readonly VAPID_PUBLIC_KEY = 'BOSYrgkbeMNdstN65i5--n3EuN9zlEJ0OvWc32qGmI1lxM1MQMsyfz4XZNc6bnhVNbrxGQinZbJy7EEKuPaJvAc';

  constructor(
    private swUpdate: SwUpdate,
    private swPush: SwPush,
    private pushSubscriptionService: PushSubscriptionService,
    private snackBar: MatSnackBar,
    private translate: TranslateService) {}

  ngOnInit() {
    this.forceSWupdate();
    this.subscribeToNotifications();
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(async evt => {
        switch (evt.type) {
          case 'VERSION_DETECTED':
              //console.log(`Downloading new app version: ${evt.version.hash}`);
              break;
          case 'VERSION_READY':
              //console.log(`Current app version: ${evt.currentVersion.hash}`);
              //console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
              await this.swUpdate.activateUpdate();
              location.reload();
              break;    
          case 'VERSION_INSTALLATION_FAILED':
              //console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
              break;
      }
      });
    }
  }

  forceSWupdate() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.update();
        }
      });
    }
  }

  subscribeToNotifications() {
    this.swPush.requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
    })
    .then((sub) => this.pushSubscriptionService.saveSubscription(sub).subscribe( (result) => {
      console.log('push',result);
      if (result) {
        if (Notification.permission === 'granted') {
          navigator.serviceWorker.getRegistration().then((reg) => {
            const options = {
              body: this.translate.instant('KEEP_YOU_POSTED'),
              icon: 'assets/icons/android-chrome-192x192.png',
              image: 'assets/images/beefund-banner.png',
              vibrate: [100, 50, 100],
            };
            reg.showNotification(this.translate.instant('THANKS_FOR_REGISTRING'), options);
          });
        }
        this.snackBar.open(this.translate.instant('PUSH_SUBSCRIPTION'), 'X', { duration: 3000 });
      }
    })).finally(() => {
      this.getLocation();
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((location) => {
        return location;
      });
    }
  }

  onActivate(event) {
    window.scroll(0, 0);
  }
}
